import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn';
import {
  ToggleGroup,
  ToggleGroupItem as PrimitiveToggleGroupItem,
} from '../../primitive/toggle-group';

function ToggleGroupItem({ className, ...props }: ComponentProps<typeof PrimitiveToggleGroupItem>) {
  return <PrimitiveToggleGroupItem className={cn('text-[13px]', className)} {...props} />;
}

export { ToggleGroup, ToggleGroupItem };
